export const REAL_GIFTS_TYPE = "realGifts";
export const VIRTUAL_GIFTS_TYPE = "virtualGifts";
export const WELCOME_POPUP_TYPE = "welcomePopup";
export const GALLERY_SWIPE_TYPE = "gallerySwipe";
export const FEED_UPDATE_TYPE = "feedUpdate";
export const PAID_VIDEO_TYPE = "paidMailVideo";
export const STIKERS_TYPE = "stickers";
export const LIVE_CHAT_TYPE = "liveChat";
export const VIP_SUPPORT_TYPE = "support";
export const DISAPPEARING_MEDIA_TYPE = "disappearingMedia";

export const onboardingConfig = {
  1: REAL_GIFTS_TYPE,
  2: VIRTUAL_GIFTS_TYPE,
  3: WELCOME_POPUP_TYPE,
  4: GALLERY_SWIPE_TYPE,
  5: FEED_UPDATE_TYPE,
  6: PAID_VIDEO_TYPE,
  7: STIKERS_TYPE,
  8: LIVE_CHAT_TYPE,
  9: VIP_SUPPORT_TYPE,
  10: DISAPPEARING_MEDIA_TYPE,
};
